/**
 * Números que sobem: qualquer elemento marcado com [data-count] (ex.: "100%", "30 dias")
 * anima a partir de zero até o valor escrito nele quando entra na tela, uma vez só — igual
 * às estatísticas da Renova Be. Funciona com sufixo livre e preserva casas decimais
 * ("4,9★" conta até 4,9, não vira 5). Sem JavaScript, ou para quem prefere menos movimento,
 * o valor final já aparece direto, sem animar.
 */
(() => {
  // Mais de uma seção na mesma página (ex.: "Ciência" e "Avaliações") carrega este script cada
  // uma a sua vez. Sem esta trava, ele rodaria de novo a cada seção: a segunda vez leria o texto
  // que a primeira já tinha zerado ("0%") como se fosse o valor original, e ficaria animando
  // "de 0 até 0" por cima da contagem certa — sobrescrevendo o número a cada quadro.
  if (window.themeCountUp) return;
  window.themeCountUp = true;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const duration = 1400;

  const count = (el) => {
    // Cada número anima uma vez só (a seção pode ser redesenhada pelo editor de temas)
    if (el.dataset.counted) return;
    el.dataset.counted = 'true';

    // Separa o número inicial (com casas decimais, vírgula ou ponto) do resto do texto.
    const match = el.textContent.trim().match(/^(\d+(?:[.,]\d+)?)(.*)$/s);
    if (!match) return; // texto sem número no início (ex.: "Grátis"): mantém como está

    const [, numberText, suffix] = match;
    const decimals = (numberText.split(/[.,]/)[1] || '').length;
    const decimalChar = numberText.includes(',') ? ',' : '.';
    const target = parseFloat(numberText.replace(',', '.'));
    const format = (value) => `${value.toFixed(decimals).replace('.', decimalChar)}${suffix}`;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      el.textContent = format(target);
      return;
    }

    el.textContent = format(0);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        const start = performance.now();
        const step = (now) => {
          const progress = Math.min(1, (now - start) / duration);
          const eased = 1 - (1 - progress) ** 3; // easeOutCubic: acelera e desacelera no final
          el.textContent = format(target * eased);
          if (progress < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-count]').forEach(count);
  boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
